//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import leftTitle from '@/assets/jfcj/left_title.png'
import rightTitle from '@/assets/jfcj/right_title.png'
export default {
  name: 'header-dialog',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      left_title: leftTitle,
      right_title: rightTitle
    }
  },
  created () { },
  mounted () { },
  methods: {
  }
}
